export default "__VITE_ASSET__D41_9cJR__"